import type { ReactNode } from "react";
import { useReveal } from "~/lib/hooks/useReveal";

/**
 * Marca a seção como visível quando ela entra na tela, para os filhos com
 * `data-revela` subirem em sequência e os fios se desenharem.
 *
 * O movimento mora no CSS; aqui só mora o gatilho.
 */
export function Revela({
  children,
  className,
  rotuladoPor,
  rotulo,
}: {
  children: ReactNode;
  className?: string;
  rotuladoPor?: string;
  rotulo?: string;
}) {
  const { ref, props } = useReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className={className}
      aria-labelledby={rotuladoPor}
      aria-label={rotulo}
      {...props}
    >
      {children}
    </section>
  );
}
